export enum AnchorTypes {
        Transfer = "FluidTransfert",
        InstrumentationPort = "InstrumentationPort",
        SamplingPort = "SamplingPort",
   
  }